import { render, staticRenderFns } from "./OptionsButton.vue?vue&type=template&id=66582b78&scoped=true"
import script from "./OptionsButton.vue?vue&type=script&lang=js"
export * from "./OptionsButton.vue?vue&type=script&lang=js"
import style0 from "./OptionsButton.vue?vue&type=style&index=0&id=66582b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66582b78",
  null
  
)

export default component.exports